import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'reachNameDisplay'
})
export class ReachNameDisplayPipe implements PipeTransform {

  transform(value: string, reachInPWAP: boolean, reachNumber: number): string {
    if (reachInPWAP) {
      return `${value} (PWAP Reach ${reachNumber})`
    }
    return value;
  }

}
